let init = function ($element, options) {
  $element.select2(options)
}

let initHeavy = function ($element, options) {
  let settings = $.extend({
    ajax: {
      data: function (params) {
        let result = {
          term: params.term,
          page: params.page,
          field_id: $element.data('field_id')
        }

        let dependentFields = $element.data('select2-dependent-fields')
        if (dependentFields) {
          dependentFields = dependentFields.trim().split(/\s+/)
          $.each(dependentFields, function (i, dependentField) {
            result[dependentField] = $('[name=' + dependentField + ']', $element.closest('form')).val()
          })
        }

        return result
      },
      processResults: function (data, page) {
        return {
          results: data.results,
          pagination: {
            more: data.more
          }
        }
      }
    }
  }, options)

  $element.select2(settings)
}

$.fn.djangoSelect2 = function (options) {
  let settings = $.extend({}, options)
  $.each(this, function (i, element) {
    let $element = $(element)
    if ($element.hasClass('django-select2-heavy')) {
      initHeavy($element, settings)
    } else {
      init($element, settings)
    }
  })
  return this
}
